import { useState } from "react";
import { useSiteMutations } from "../../../hooks/useSiteMutations";
import { useToast } from "../../../mantine/notifications/useToast";
import type { Site } from "../../../utils/backend-types";
import { DeleteConfirmationModal } from "../../BuildingBlocks/Layout/Modals/DeleteConfirmationModal/DeleteConfirmationModal";
import { DeleteSiteModalBodyElement } from "./DeleteSiteModalBodyElement";

function DeleteSiteModal({
  site,
  toggleModal,
  onSuccess
}: {
  site: Site;
  toggleModal: () => void;
  onSuccess: () => void;
}) {
  const { showErrorToast } = useToast();
  const [allowDelete, setAllowDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const { deleteMutation } = useSiteMutations(site.id);

  const modalBodyElement = (
    <DeleteSiteModalBodyElement
      siteName={site.name}
      onVerificationTextChange={setAllowDelete}
    />
  );

  async function deleteSite(site: Site) {
    setIsDeleting(true);
    try {
      await deleteMutation.mutateAsync(site.id);
      onSuccess();
    } catch (error) {
      showErrorToast(error);
    } finally {
      setIsDeleting(false);
    }
  }

  return (
    <DeleteConfirmationModal
      className="DeleteSiteModal"
      isConfirmationBtnDisabled={!allowDelete}
      isLoading={isDeleting}
      modalBodyElement={modalBodyElement}
      name={site.name}
      opened
      toggleModal={toggleModal}
      onConfirm={() => deleteSite(site)}
    />
  );
}

export { DeleteSiteModal };
